export default "__VITE_ASSET__21b58051__"